import styled from "styled-components";

const ConversationFeedback = styled.div`
  background: ${(props) => props?.theme?.themeConfig?.secondaryColor};
  padding: 20px 45px;
  border-radius: 10px;
  margin-left: 30px;
  margin-right: 30px;
  position: relative;
  form {
    background: none;
  }

  p {
    margin: 0px;
    padding:10px 0px;
    text-align: center;
    font-size:15px;
  }
  .radioOptions, .feedbackbox, button {
    margin-top: 20px;
  }
  .radioOptions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    label {
      text-align: center;
      font-size:15px;
    }
    input {
      display: block;
      text-align: center;
      margin:0px;
    }
  }
  .feedbackbox {
    text-align: center;
    width: 100%;
    textarea {
      border: 1px solid var(--input-border-color);
      max-width: 450px;
      width: 100%;
      font-size:15px;
      height:50px;
      outline:none;
      font-family: 'Poppins', sans-serif;
      padding:5px;
      background-color: #FFFFFF;
      resize: vertical;
      min-height: 100px;
    }
  }

  .voa_close_59o7kg {
    font-size: 20px;
    position: absolute;
    right: 20px;
    background: ${(props) => props?.theme?.themeConfig?.primaryColor};
    height: 24px;
    width: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    color: #FFFFFF;
    line-height: 28px;
    cursor: pointer;
    align-items: center;
  }
  button {
    padding: 10px;
    border-radius: 4px;
    width: auto;
    margin: 20px auto;
    font-size:14px;
    font-family: inherit;
    &:disabled {
      background-color: #80907b;
      cursor:default;
    }
  }
  .error {
    text-align: center;
    width: 300px;
    margin: 0px auto;
    font-size:14px;
    color: red;
  }
`

export default ConversationFeedback;
